import React from 'react';
// Import Swiper styles
import { Navigation, Pagination,Lazy} from 'swiper';
import 'swiper/css';
import "swiper/css/lazy";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {Swiper, SwiperSlide} from "swiper/react";
import * as images from "./images/images";


const imageDataSource:string[] = [
    images.menu_00,images.menu_01,images.menu_02,images.menu_03,images.menu_04,images.menu_05,images.menu_06,images.menu_07,images.menu_08,images.menu_09,
    images.menu_10,images.menu_11,images.menu_12,images.menu_13,images.menu_14,images.menu_15,images.menu_16,images.menu_17,images.menu_18,images.menu_19,
    images.menu_20,images.menu_21,images.menu_22,images.menu_23,images.menu_24,images.menu_25,images.menu_26,images.menu_27,images.menu_28,images.menu_29,
    images.menu_30,images.menu_31,images.menu_32,images.menu_33,images.menu_34,images.menu_35,images.menu_36,images.menu_37,images.menu_38,images.menu_39,
    images.menu_40,images.menu_41,images.menu_42,images.menu_43,images.menu_44,images.menu_45,images.menu_46,images.menu_47,images.menu_48,images.menu_49,
    images.menu_50,images.menu_51,images.menu_52,images.menu_53,images.menu_54,images.menu_55,images.menu_56,images.menu_57,images.menu_58,images.menu_59,
    images.menu_60,images.menu_61,images.menu_62,images.menu_63,images.menu_64,images.menu_65,images.menu_66,images.menu_67,images.menu_68,images.menu_69
    ]
function App() {
    const bgWidth = 907;
    const bgHeight = 1280;
    const viewportWidth = document.body.offsetWidth;
    const viewportHeight = document.body.offsetHeight;

    let imageHeight = viewportHeight;
    let imageWidth = (viewportHeight / bgHeight) * bgWidth
    if(imageWidth > viewportWidth){
        imageHeight = viewportWidth / imageWidth * imageHeight;
        imageWidth = viewportWidth;
    }
    let topMargin = 0;
    if(viewportHeight > imageHeight){
        topMargin = (viewportHeight - imageHeight) / 2;
    }
    return (<div style={{background:'black',paddingTop:topMargin,height:'100%'}}><Swiper
        loop={true}
		slidesPerView={"auto"}
        spaceBetween={20}
        centeredSlides={true}
        pagination={{
            clickable: true,
        }}
        modules={[Lazy,Pagination,Navigation]}
        lazy={{loadPrevNext:true,loadPrevNextAmount:10}}
    >
        {imageDataSource.map(value => {
            return <SwiperSlide key={value} style={{background:'black',width:imageWidth,height:imageHeight}} >
                    <img  data-src={value} alt={'Menu Rempah'} style={{width:imageWidth,height:imageHeight,borderRadius:20}} width={imageWidth} height={imageHeight} className="swiper-lazy"/>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"/>
                    <div style={{width:imageWidth,height:imageHeight,top:0,position:'absolute',boxShadow:'0 0 2px 3px rgba(0,0,0,1) inset,0 0 30px 3px rgba(0,0,0,0.3) inset',zIndex:1,borderRadius:20}}/>
            </SwiperSlide>
        })}
    </Swiper></div>);
}

export default App;
